import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("meta", {
  name: "prerender-status-code",
  content: "404"
}, null, -1)
const _hoisted_2 = { id: "page-404" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "button-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.logoUrl,
            alt: _ctx.domain + ' logo'
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('NotFound.title')), 1),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('NotFound.message')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "button button--primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('NotFound.link')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}